import React, { Fragment, useEffect, useState } from "react";
import { Image, Button, Row, Col, Table } from "react-bootstrap";
import moment from "moment";
import { NEW_PAYMENT_TYPE } from "../../../../enums/OrderEnums";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert, successAlert } from "../../../../function/alert";
import ExpRejectionModal from "./Modals/ExpRejectionModal";
import ViewExpReqDetails from "./ViewExpReqDetails";
import SendSmsNew from "../../../reusableComponents/allPopupReusable/SendSmsNew";
import NotificationsNew from "../../../reusableComponents/allPopupReusable/NotificationsNew";
import LocationReusable from "../../../../components/reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import CallingIconButtonActionFile from "../../../reusableComponents/allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";
import ExpEditWaitTime from "./Modals/ExpEditWaitTime";
import NewCountDown from "../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import { useHistory } from "react-router-dom";
import ReadMore from "../../../reusableComponents/ReadMore";

const ExpRequestBodyCard = ({ expRequest, onStatusChange, page,scanData, resetScan, ...props }) => {
  const endTime = moment().valueOf();
  const startTime = moment(expRequest.createdAt).valueOf();

  const history = useHistory();
  const[viewExpviaScan,setViewExpviaScan] = useState(false);

  const [waitData, setWaitData] = useState({ waitTime: expRequest.waitTime, waitTimeDate: expRequest.waitTimeDate });

  const [btnData, setBtnData] = useState({
    back: "",
    next: ""
  })
  const [enablereschedule, setreschedule] = useState(true);
  useEffect(() => {
    if (expRequest?.experienceId?.rescheduleAllowed && (expRequest?.status === 'PENDING' || expRequest?.status === 'NOTSEATED')) {
      setreschedule(false);
    } else {
      setreschedule(true);
    }
  }, [expRequest])


  const statusName = {
    'PENDING': { name: 'Pending', background: "#FFF6DF", color: "#E2A200", sideBar: "#FCB62B" },
    'NOTSEATED': { name: 'Not Seated', background: "#FBEABF", color: "#C18A00", sideBar: "#FCB62B" },
    'SEATED': { name: 'Seated', background: "#e6ffdf", color: "#25A900", sideBar: "#37AC1E" },
    'COMPLETED': { name: 'Completed', background: "#e6ffdf", color: "#25A900", sideBar: "#37AC1E" },
    'CANCELLED': { name: "Cancelled", background: "#ffdfdf", color: "#ee3a23", sideBar: "#FFFFFF" },
    'REJECTED': { name: "Rejected", background: "#ffdfdf", color: "#ee3a23", sideBar: "#FFFFFF" }
  };

  const statusBackIcon = {
    'PENDING': require("../../../../assets/images/iconButton/cancelButton.svg"),
    'NOTSEATED': require("../../../../assets/images/iconButton/backarrowred.svg"),
    'SEATED': require("../../../../assets/images/iconButton/backarrowred.svg"),
    'COMPLETED': require("../../../../assets/images/iconButton/reset-button.png"),
    'CANCELLED': require("../../../../assets/images/iconButton/reset-button.png"),
    'REJECTED': require("../../../../assets/images/iconButton/reset-button.png"),
  }

  const [modal, setModal] = useState("");

  let msDifference = endTime - startTime;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function timeConvert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  useEffect(() => {
    let d = {
      back: "",
      next: ""
    }
    if (expRequest.status === 'PENDING') {
      d.back = "Reject";
      d.next = "Accept";
    } else if (expRequest.status === 'NOTSEATED') {
      d.back = "";
      d.next = "Seat";
    } else if (expRequest.status === 'SEATED') {
      d.back = "Not Seated";
      d.next = "Complete";
    } else if (expRequest.status === 'COMPLETED') {
      d.back = "Reset";
      d.next = ""
    }
    setBtnData(d);
  }, [expRequest])

  const onCancel = (data, refundPercentage) => {
    onStatusChange('history', { status: "REJECTED", cancelReason: data, refundPercentage: refundPercentage }, expRequest._id);
    setModal("")
  }

  const onBack = () => {
    let obj = {
      status: 'CANCELLED'
    }
    let type = ""
    if (expRequest.status === 'PENDING') {
      type = "history";
      obj.status = 'REJECTED';
      obj.cancelReason = "Rejected"
      setModal('PENDING')
    } else if (expRequest.status === 'NOTSEATED') {
      type = "pending";
      obj.status = 'PENDING';
      obj.cancelReason = "Pending"
    } else if (expRequest.status === 'SEATED') {
      type = "booking";
      obj.status = 'NOTSEATED';
      obj.cancelReason = "Not seated"
    } else if (expRequest.status === 'COMPLETED') {
      type = "booking";
      obj.status = 'SEATED';
    }
    if (expRequest.status !== 'PENDING') {
      onStatusChange(type, obj, expRequest._id)
    }
  }

  const onNext = () => {
    let obj = {
      status: 'CANCELLED'
    }
    let type = "";
    if (expRequest.status === 'PENDING') {
      type = "booking"
      obj.status = 'NOTSEATED';
    } else if (expRequest.status === 'NOTSEATED') {
      type = "booking"
      obj.status = 'SEATED';
    } else if (expRequest.status === 'SEATED') {
      type = "history"
      obj.status = 'COMPLETED';
    }
    if(obj.status == "COMPLETED" && expRequest?.paymentStatus !== 1 ){
      errorAlert("You can't perform this action because payment is not done");
    } else {
      onStatusChange(type, obj, expRequest._id)
      }
  }
  const [trdetails, setTrdetails] = useState(false)
  const showTr = () => {
    setTrdetails(!trdetails)
  }

  const onWaitTimeEdit = async (id, time) => {
    try {
      let expReq = await amApi.patch(`/expRequest/${id}`, { waitTime: time });
      setWaitData({ waitTime: expReq?.data?.waitTime, waitTimeDate: expReq?.data?.waitTimeDate });
    } catch (err) {
      errorAlert('Something Went Wrong, try again later');
    }
  }


  const updatedTime = new Date(
    expRequest?.status === 'PENDING' ? waitData?.waitTimeDate : expRequest?.reservationTime
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = waitData?.waitTime * 60 * 1000 || 0;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const totalpaxvalue = () => {
    let value = 0;
    if (expRequest?.package?.count < 1) {
      value = ((expRequest?.adultCount || 0) + (expRequest?.kidsCount || 0));
      return value
    } else {
      value = ((expRequest?.adultCount || 0) + (expRequest?.kidsCount || 0)) + ((expRequest?.package?.adults + expRequest?.package?.kids))
      return value
    }
  }
 
  useEffect(()=>{
    if(scanData?.expRequestId === expRequest?.requestId || scanData?.exp_id === expRequest?._id){
      setViewExpviaScan(true)
    }
  },[expRequest,scanData])

  const onClickPayLater = (data) => {
    let existingData = JSON.parse(JSON.stringify(expRequest));
    // dispatch({ type: CREATE_ORDER_VENDOR, payload: existingData });
    history.push(`/special/addGuests/${existingData?._id}`);
  };

  return (
    <>
      <tbody className="w-100 super-admin-all-vendor-main-table-body seating-dashboard-body-new" key={expRequest.requestId}>
        <tr className="w-100 p-0">
          <td className=" w-100 p-0">
            <table className="w-100 p-0 ">
              <tbody className="sd_body_css" style={{background : "#ffffff"}}>
                <tr
                  className={`cursor enGrayBorderBox sd_body_tr ${"td_b_o"}`}
                  style={{
                    border: "none",
                    borderRadius: "5px 0px 0px 5px",
                    borderLeft: `1.25vw solid ${statusName[expRequest.status].sideBar}`,
                  }}
                  onClick={showTr}
                >
                  <td
                    style={{ width: "2%" }}
                    className="table-body-left-vertical-badge-td"
                  >
                    <div
                      className="f9-500"
                      style={{ letterSpacing: 1 }}
                    >
                      {expRequest?.experienceId?.subCategory?.title?.toUpperCase()}
                    </div>
                  </td>
                  <td style={{ width: "15%" }} className="">
                    <p className="font_20_m">{expRequest?.userDetails?.name || ""}</p>
                    <p className="f9-500 my-1" style={{ color: "#EE3A23" }}>#{expRequest?.requestId}</p>
                  </td>
                  <td style={{ width: "15%" }} className="">
                    <div className="total-pax-body">
                      <div className="col d-flex justify-content-start p-0">
                        <div className="total-pax-body-inside">
                          <p className="font_24_b">
                            {((expRequest?.adultCount || 0) + (expRequest?.kidsCount || 0)) + ((expRequest?.package?.adults + expRequest?.package?.kids))}
                          </p>
                        </div>
                        <div className="total-adult-kids">
                          {expRequest?.adultCount + expRequest.package.adults === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/adult.svg")}
                                alt="Adult"
                                title="Adult"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {expRequest?.adultCount + expRequest.package.adults}
                              </p>
                            </div>
                          )}
                          {expRequest?.kidsCount + expRequest.package.kids > 0 ? (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/kids.svg")}
                                alt="Kids"
                                title="Kids"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {expRequest?.kidsCount + expRequest.package.kids}
                              </p>
                            </div>
                          ) : null}
                        </div>
                        <div className="total-highchair-handicapp">
                          {expRequest?.highchairCount === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/highchair.svg")}
                                alt="Highchair"
                                title="Highchair"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {expRequest?.highchairCount}
                              </p>
                            </div>
                          )}
                          {expRequest?.handicapCount === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/handicap.svg")}
                                alt="Handicapped"
                                title="Handicapped"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {expRequest?.handicapCount}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="text-center"
                    style={{ width: "20%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                      // openEditWaitTimeModel(e);
                    }}
                  >
                    <div className="date-time-timer-body">
                      <ExpEditWaitTime

                        disabled={expRequest.status === "PENDING" || expRequest.status === "CANCELLED" || expRequest.status === "COMPLETED"}
                        noDisplay={
                          <div
                            className="timer-section text-center"
                          >
                            <div
                              className="f14-700"
                              style={{ color: "#000000" }}
                            >
                              <NewCountDown waitNew={expRequest.status === "CANCELLED" || expRequest.status === "COMPLETED" ? 0 : diff} />
                            </div>
                          </div>
                        }
                        onWaitTimeEdit={onWaitTimeEdit}
                        id={expRequest._id}
                      />
                    </div>
                    <p className="font_16_r">
                      {moment(expRequest?.reservationTime).format("Do MMM YYYY")}
                    </p>
                    <p className="font_16_r">
                      {moment(expRequest?.reservationTime).format("hh:mm A")}
                    </p>
                  </td>
                  <td className="text-center"
                    style={{
                      width: "15%",
                    }}
                  >
                    <span className="f12-500 d-flex align-items-center justify-content-center">
                      <i className="fa fa-inr mr-1" aria-hidden="true"></i>
                      <div className="d-flex ml-1 align-items-center">
                        {expRequest?.paymentData?.totalAmount}{" "}
                        |{" "}
                        <div
                          className=" f10-500 ml-1"
                          style={{ color: expRequest?.paymentStatus === 1 ? "#3E9121" : "#EE3A23" }}
                        >
                          {expRequest?.paymentStatus === 1
                            ? "PAID"
                            : expRequest?.paymentStatus === 0
                              ? "UNPAID"
                              : expRequest?.paymentStatus === 3
                                ? "FAILURE"
                                : "N/A"}
                        </div>
                      </div>
                    </span>
                    <hr className="my-1" />
                    {expRequest.paymentStatus !== 1 ? (
                      expRequest.status === "CANCELLED" ? (
                        ""
                      ) : (
                        <div className="mt-1 mb-1 text-center">
                          <button
                            className="btn bg-danger text-white f10-400 px-2 py-1"
                            onClick={() => 
                              onClickPayLater(props.orderDetails)
                            }
                          >
                            Pay Now
                          </button>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                    <div className="text-center">
                      <div className="f12-500">
                        {expRequest?.splitPayment ? (
                          <>Split Payment</>
                        ) : (NEW_PAYMENT_TYPE[expRequest.paymentData?.paymentMethod])}
                      </div>
                    </div>
                  </td>
                  <td className="text-center"
                    style={{
                      width: "15%",
                    }}
                  >
                    <p className="font_16_m">
                      {expRequest?.experienceId?.name}
                      <br />
                      {expRequest?.experienceId?.expId}
                    </p>
                  </td>
                  <td className="text-center"
                    style={{
                      width: "20%",
                    }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <div className={
                      true
                        ? "action-section-body d-flex align-items-center justify-content-center f10-500"
                        : "action-section-body align-items-center f10-500"
                    }
                    >
                      {
                        (page === "booking" && moment(expRequest?.reservationTime).format("YYYY-DD-MM") == moment().format("YYYY-DD-MM") && btnData?.back) || (page !== "booking" && btnData?.back) ?
                          <div className="d-flex flex-column mr-2" onClick={onBack}>
                            <Image
                              src={statusBackIcon[expRequest.status]}
                              height={`${expRequest?.status === "PENDING" ? "38px" : "48px"}`}
                            />
                            <div>{btnData?.back}</div>
                          </div>
                          : <></>
                      }
                      <div className="middle-timer m-0">
                        <div
                          className="seating-status"
                          style={{
                            backgroundColor: `${statusName[expRequest.status].background}`,
                          }}
                        >
                          <p
                            className="font_16_m"
                            style={{
                              color: `${statusName[expRequest.status].color}`,
                            }}
                          >
                            {statusName[expRequest.status].name}
                          </p>
                        </div>
                        <div className="f9-400">
                          {timeConvert(minutes)}
                        </div>
                      </div>
                      {(page === "booking" && moment(expRequest?.reservationTime).format("YYYY-DD-MM") == moment().format("YYYY-DD-MM") && btnData?.next) || (page !== "booking" && btnData?.next) ?
                        <div className="d-flex flex-column ml-2" onClick={onNext}>
                          <Image
                            src={require("../../../../assets/images/iconButton/Nextarrowgreen.svg")}
                            height="48px"
                          />
                          <div>{btnData?.next}</div>
                        </div> : <></>
                      }
                    </div>
                    <ViewExpReqDetails onClickPayLater={onClickPayLater} dataSend={expRequest} diff={diff} onWaitTimeEdit={onWaitTimeEdit} twt={timeConvert(minutes)}  viewOnScan={viewExpviaScan} hidden={true} btnData={btnData} page={page} statusBackIcon={statusBackIcon} statusName={statusName} onBack={onBack} onNext={onNext} resetScan={resetScan} />
                  </td>
                </tr>
                {trdetails && (
                  <>
                    <tr className="sd_accordion_body px-0">
                      <div className="container-fluid position-relative">
                        <div className="row">
                          <div
                            className="col-4"
                            style={{ borderRight: "1px solid #E0E0E0" }}
                          >
                            <div className="f14-500">More details</div>
                            <br />
                            <div
                              className="more-actions-orders-desc d-flex align-items-center justify-content-start mb-2"
                              onClick={(e) => {
                                if (!e) var e = window.event;
                                e.cancelBubble = true;
                                if (e.stopPropagation) e.stopPropagation();
                              }}
                            >
                              <CallingIconButtonActionFile
                                orderDetails={expRequest?.userDetails}
                                actionType="conbinedName"
                              />
                              <SendSmsNew
                                mobile_number={expRequest?.userDetails?.mobileNumber}
                                first_name={
                                  expRequest?.userDetails?.name
                                    ? expRequest?.userDetails.name
                                    : ""
                                }
                                type={5}
                                id={expRequest?._id}
                              />
                              <NotificationsNew
                                id={expRequest?._id}
                                type={5}
                                dataSend={expRequest}
                              />
                              <ChatWindow
                                data={expRequest}
                                text={"expRequest"}
                                actionBy="expRequest"
                              />
                              <ViewExpReqDetails onClickPayLater={onClickPayLater} dataSend={expRequest} diff={diff} onWaitTimeEdit={onWaitTimeEdit} twt={timeConvert(minutes)}  viewOnScan={viewExpviaScan}  btnData={btnData} page={page} statusBackIcon={statusBackIcon} statusName={statusName}  onBack={onBack} onNext={onNext}/>{" "}
                              {history?.location?.pathname?.includes("history") ? null :
                                <Button
                                  variant="link"
                                  className="enIconBtn mr-3"
                                  disabled={enablereschedule}
                                  onClick={() => history.push(`/${expRequest.expType.toLowerCase()}/editGuests/${expRequest._id}`)}
                                >
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/pencil.svg")}
                                    alt="Edit"
                                    title="Edit"
                                    fluid
                                  />
                                </Button>
                              }
                            </div>
                          </div>
                          <div
                            className="col-2"
                            style={{ borderRight: "1px solid #E0E0E0" }}
                          >
                            <p className="font_20_m text-center mb-2">Track User Location</p>
                            <LocationReusable
                              dataSend={props.dinerInfo}
                              //  socket={props.socket}
                              disabled={
                                true
                              }
                            />
                          </div>
                          <div
                            className="col-2"
                            style={{ borderRight: "1px solid #E0E0E0" }}
                          >
                            <p className="font_20_m">Special Occasion</p>
                            <div className="d-flex mt-3">
                              <p className="font_16_r" style={{ wordBreak: "break-word" }} >
                                {expRequest?.occasion || 'N/A'}
                              </p>
                            </div>
                          </div>
                          <div
                            className="col-2"
                          >
                            <p className="font_20_m">Status</p>
                            <div className="d-flex mt-3">
                              <div
                                className={`${expRequest.status === "NOTSEATED"
                                  ? "b_c_orange"
                                  : expRequest.status === "SEATED"
                                    ? "b_c_light_green"
                                    : expRequest.status ===
                                      "CANCELLED" ||
                                      expRequest.status === "REJECTED"
                                      ? "b_c_red"
                                      : expRequest.status === "COMPLETED"
                                        ? "b_c_green"
                                        : "b_c_orange"
                                  } status_blink_box`}
                              ></div>
                              <p className="font_16_m">
                                {expRequest?.status}
                              </p>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div>
                          <div>
                            <div className="f18-700 px-2 pb-3 text-dark">
                              Ticket Details
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <div className="col-6">
                              <Row className="px-3">
                                <Col lg={3} md={3} className="py-3">
                                  <div className="f12-500 pb-3">Ticket type</div>
                                </Col>
                                <Col lg={3} md={3} className="py-3">
                                  <div className="f12-500 pb-3">Count</div>
                                </Col>
                                <Col lg={3} md={3} className="py-3">
                                  <div className="f12-500 pb-3">Ticket Price</div>
                                </Col>
                              </Row>
                              {expRequest?.package?.count ?
                                <>
                                  <Row className="px-3">
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3">Package ({`${expRequest?.package?.adults / expRequest?.package?.count}`} Adults{`${expRequest?.package?.kids / expRequest?.package?.count ? `, ${expRequest?.package?.kids / expRequest?.package?.count} Kids` : ""}`})</div>
                                    </Col>
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3"> {expRequest?.package?.count}</div>
                                    </Col>
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3">{expRequest?.package?.price}/-</div>
                                    </Col>
                                  </Row>
                                </>
                                :
                                null}
                              <>
                                {expRequest?.adultCount > 0 ?
                                  <Row className="px-3">
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3">Adults</div>
                                    </Col>
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3"> {expRequest?.adultCount}</div>
                                    </Col>
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3">{expRequest?.adultPrice}/-</div>
                                    </Col>
                                  </Row>
                                  : null}

                                {expRequest?.kidsCount > 0 ? (
                                  <Row className="px-3">
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3">Kids</div>
                                    </Col>
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3"> {expRequest?.kidsCount}</div>
                                    </Col>
                                    <Col lg={3} md={3} className="py-3">
                                      <div className="f12-500 pb-3">{expRequest?.kidsPrice}/-</div>
                                    </Col>
                                  </Row>)
                                  : null}
                              </>
                            </div>
                            <div className="d-flex flex-wrap">
                              <div className="col-6 p-2">
                                <p className="f14-500">Inclusions</p>
                                <p className="f12-400">
                                  {expRequest?.experienceId?.userBenefits.length > 0 ? <ReadMore
                                    text={expRequest?.experienceId?.userBenefits || ""}
                                    minLength={
                                      expRequest?.experienceId?.userBenefits?.length < 50
                                        ? expRequest?.experienceId?.userBenefits?.length
                                        : 50
                                    }
                                    charLength={expRequest?.experienceId?.userBenefits?.length}
                                  /> : 'N/A'}
                                </p>
                              </div>
                              <div className="col-6 p-2">
                                <p className="f14-500">What type food users get</p>
                                <p className="f12-400">
                                  {expRequest?.experienceId?.foodItems.length > 0 ? <ReadMore
                                    text={expRequest?.experienceId?.foodItems || ""}
                                    minLength={
                                      expRequest?.experienceId?.foodItems?.length < 50
                                        ? expRequest?.experienceId?.foodItems?.length
                                        : 50
                                    }
                                    charLength={expRequest?.experienceId?.foodItems?.length}
                                  /> : 'N/A'}
                                </p>
                              </div>
                              <div className="col-6 p-2">
                                <p className="f14-500">Add on Services</p>
                                <p className="f12-400">
                                  {expRequest?.experienceId?.addOnDesc.length > 0 ? <ReadMore
                                    text={expRequest?.experienceId?.addOnDesc || ""}
                                    minLength={
                                      expRequest?.experienceId?.addOnDesc?.length < 50
                                        ? expRequest?.experienceId?.addOnDesc?.length
                                        : 50
                                    }
                                    charLength={expRequest?.experienceId?.addOnDesc?.length}
                                  /> : 'N/A'}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody >
      {modal === 'PENDING' && (<ExpRejectionModal modal={modal} setModal={setModal} onCancel={onCancel} />)}
    </>
  );
};

export default ExpRequestBodyCard;
